import styled from "styled-components";

export const MainWrapper = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px 0;
`;

export const MainContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`;

export const Dropzone = styled.div`
  border: 2px dashed #007bff;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  margin: 20px 0;

  &:hover {
    border-color: #0056b3;
    background-color: #e9ecef;
  }

  &.active {
    border-color: #28a745;
    background-color: #d4edda;
  }

  p {
    margin: 0;
    color: #6c757d;
    font-size: 16px;
  }
`;